import { Injectable } from '@angular/core';
import { Estudo } from './estudo';
import { Observable } from 'rxjs';
import { ServiceUtil } from '../util/service.util';
import { PagerComponent } from '../paginator/pager.component';
import { SituacaoEnum } from '../util/situacao.enum';
import { EstudoQuestionario } from './estudo-questionario';
import { Periodo } from '../util/periodo';

import { HttpService } from 'ems-oauth2-client';
import { HttpHeaders } from '@angular/common/http';
import { EstudoResumo } from '../estudo-resumo/estudo-resumo';
import { map, catchError , publishReplay, refCount} from 'rxjs/operators';

@Injectable()
export class EstudoService extends ServiceUtil {

  private headers: HttpHeaders = new HttpHeaders({
    'Content-Type': 'application/json'
  });
  private url = '/sae/estudo/socioeconomico';
  private filtro: Estudo = new Estudo();

  constructor(
    private http: HttpService,
    private pagerComponent: PagerComponent
  ) {
    super();
  }

  // altera ou inclui Estudo
  public update(estudo: Estudo): Observable<Estudo> {
    const body = JSON.stringify(this.deletaVariaveisTransient(estudo));
    if (!estudo.id) {
      return this.http
        .post(this.url, body)
        .pipe(map(response => <Estudo>response),
             catchError(this.handleError),
             publishReplay(1),
             refCount());
    } else {
      return this.http
        .put(this.url + '/' + estudo.id, body)
        .pipe(map(response => <Estudo>response),
              catchError(this.handleError),
              publishReplay(1),
              refCount());
    }
  }

  public concluir(estudo: Estudo): Observable<Estudo> {
    const body = JSON.stringify(this.deletaVariaveisTransient(estudo));
      return this.http
        .put(this.url + '/' + estudo.id + '/concluir', body)
        .pipe(map(response => <Estudo>response),
              catchError(this.handleError),
              publishReplay(1),
              refCount());

  }

  // duplica um estudo. Se não for necessário, ele retorna o próprio estudo que foi enviado.
  public duplicar(estudo: Estudo): Observable<Estudo> {
    const body = JSON.stringify(estudo);
    return this.http
    .post(this.url + '/duplicar' , body)
    .pipe(map(response => <Estudo>response),
          catchError(this.handleError),
          publishReplay(1),
          refCount());
   }

  public atualiza(estudo: Estudo): Observable<Estudo> {
    const url = '/estudoinfo/' + `${estudo.id}`;
    return this.http
      .put(url, JSON.stringify(estudo), this.headers)
      .pipe(map(response => estudo),
            catchError(this.handleError));
  }

  // deleta Estudo
  public deletar(estudo: Estudo): Observable<Estudo> {
    return this.http
      .delete(this.url + '/' + estudo.id)
      .pipe(map(response => response),
            catchError(this.handleError),
            publishReplay(1),
            refCount());
  }

  // lista todos (sem filtro)
  public listar(): Observable<Estudo[]> {
    return this.http
      .get(this.url)
      .pipe(map(this.extractListData),
            catchError(this.handleError),
            publishReplay(1),
            refCount());
  }

  public inicializa() {
    return this.http
      .get(this.url + '/inicializa')
      .pipe(map(this.extractListData),
            catchError(this.handleError),
            publishReplay(1),
            refCount());
  }

  public enviarEmailAgendamento(idEstudo: number): Observable<Estudo> {
    return this.http
      .get(this.url + '/' + idEstudo + '/agendamento')
      .pipe(map(this.extractData),
            catchError(this.handleError),
            publishReplay(1),
            refCount());
  }

  // filtra
  public filtrar(filtro: Estudo, ordenar: string): Observable<Estudo[]> {
    let colocaVirgula = false;
    let novaUrl = '{';
    if (filtro.alunoRa) {
      novaUrl += 'alunoRa:"' + filtro.alunoRa + '"';
      colocaVirgula = true;
    }
    if (filtro.id) {
      if (colocaVirgula) {
        novaUrl += ', ';
      }
      novaUrl += 'id:"' + filtro.id + '"';
      colocaVirgula = true;
    }
    if (filtro.alunoNome) {
      if (colocaVirgula) {
        novaUrl += ', ';
      }
      novaUrl += 'alunoNome__contains:"' + filtro.alunoNome + '"';
      colocaVirgula = true;
    }
    if (filtro.periodo) {
      if (colocaVirgula) {
        novaUrl += ', ';
      }
      novaUrl += 'periodo:"' + filtro.periodo + '"';
      colocaVirgula = true;
    }

    if (filtro.situacao) {
      if (colocaVirgula) {
        novaUrl += ', ';
      }
      novaUrl += 'situacao:"' + filtro.situacao + '"';
      colocaVirgula = true;
    }

    if (filtro.aluCodigoCampus) {
      if (colocaVirgula) {
        novaUrl += ', ';
      }
      novaUrl += 'aluCodigoCampus:"' + filtro.aluCodigoCampus + '"';
      colocaVirgula = true;
    }

    if (filtro.alunoNivel) {
      if (colocaVirgula) {
        novaUrl += ', ';
      }
      if (filtro.alunoNivel === 2) {
        novaUrl += 'alunoNivel:"' + filtro.alunoNivel + '"';
        colocaVirgula = true;
      } else {
        novaUrl += 'alunoNivel__gt:"' + filtro.alunoNivel + '"';
        colocaVirgula = true;
      }
    }

    if (filtro.aluno) {
      if (colocaVirgula) {
        novaUrl += ', ';
      }
      novaUrl += 'aluno:"' + filtro.aluno + '"';
      colocaVirgula = true;

    }

    novaUrl += '}';
    let urlModify = this.pagerComponent.formatarUrl(this.url, novaUrl, 100, 0);

    if (filtro.filtroAtribuidosAMim) {
      urlModify += '&filtroAtribuidosAMim=1';
    }

    if (filtro.filtroNaoAtribuidos) {
      urlModify += '&filtroNaoAtribuidos=1';
    }

    if (filtro.filtroMostrarSomenteMoradia) {
      urlModify += '&filtroSomenteMoradia=1';
    }

    if (filtro.filtroResponsavel) {
      urlModify += '&filtroResponsavel="' + filtro.filtroResponsavel + '"';
    }

    if (ordenar) {
      urlModify += '&sort= ' + ordenar;
    } else {
      urlModify += '&sort= dataInclusao asc';
    }

    return this.http
      .get(urlModify)
      .pipe(map(response => {
        return <Estudo[]>response;
      }),
          catchError(this.handleError),
          publishReplay(1),
          refCount());
  }

  // recupera por id
  public getId(id: number): Observable<Estudo> {
    return this.http
      .get(this.url + '/' + id)
      .pipe(map(this.extractObjectData),
            catchError(this.handleError),
            publishReplay(1),
            refCount());
  }

  public getById(id: number): Observable<Estudo> {
    const url = `${this.url}/${id}/`;
    return this.http
      .get(url)
      .pipe(map(response => {
        return response;
      }),
      catchError(this.handleError));
  }

  public verificaPerfilEstudoPreliminar(id: number): Observable<Boolean> {
    return this.http
      .get(this.url + '/' + id + '/possuiPerfil')
      .pipe(map(response => {
        const result = response;
        return result.ok;
      }),
        catchError(this.handleError),
        publishReplay(1),
        refCount());
  }

  public atribuir(estudo: Estudo): Observable<Boolean> {
    const body = JSON.stringify(estudo);
    return this.http
      .put(this.url + '/' + estudo.id + '/associar', body)
      .pipe(map(response => <Estudo>response),
         catchError(this.handleError),
         publishReplay(1),
         refCount());
  }

  public desassociar(estudo: Estudo): Observable<Estudo> {
    const body = JSON.stringify(estudo);
    return this.http
      .put(this.url + '/' + estudo.id + '/desassociar', body)
      .pipe(map(response => <Estudo>response),
          catchError(this.handleError),
          publishReplay(1),
          refCount());
  }

  public getEstudoPorMatricula(id: string): Observable<Estudo> {
    return this.http
      .get(this.url + '/inicializa/' + id)
      .pipe(map(this.extractObjectData),
          catchError(this.handleError),
          publishReplay(1),
          refCount());
  }

  public getPeriodoAtual(): Observable<Periodo[]> {
    return this.http.get('/academico/periodo/graduacao/atual')
              .pipe(map(response => {
                return <Periodo[]> response;
               }),
                catchError(this.handleError),
                publishReplay(1),
                refCount());
  }


  public getQuestionario(
    idResposta: number,
    idEstudo: number,
    nomeQuestionario: string
  ): Observable<EstudoQuestionario> {
    let novaUrl = this.url + '/questionario';
    novaUrl += '/?nomeQuestionario=' + nomeQuestionario;
    if (idResposta) {
      novaUrl += '&idResposta=' + idResposta;
    }

    if (idEstudo) {
      novaUrl += '&idEstudo=' + idEstudo;
    }

    return this.http
      .get(novaUrl)
      .pipe(map(response => <EstudoQuestionario>response),
         catchError(this.handleError),
         publishReplay(1),
         refCount());
  }

  public controlaBotaoSalvar(situacao: number, ehAluno: boolean) {
    if (
      situacao === SituacaoEnum.NaoConcluido ||
      situacao === SituacaoEnum.ParaCorrecao
    ) {
      // 1 eh NaoConcluido
      return true;
    } else if (
      situacao === SituacaoEnum.EmAnalise ||
      situacao === SituacaoEnum.Corrigido ||
      situacao === SituacaoEnum.Homologado
    ) {
      if (ehAluno) {
        // em análise e corrigido, quem nao eh aluno pode alterar
        return false;
      } else {
        return true;
      }
    } else if (situacao === SituacaoEnum.Pontuado) {
      return false;
    }
  }

  public recuperaQuestionarioValidacao(idEstudo: number): Observable<EstudoQuestionario[]> {
    return this.http
      .get(this.url + '/questionario/validacao/' + idEstudo)
      .pipe(map(response => <EstudoQuestionario[]>response),
         catchError(this.handleError),
         publishReplay(1),
         refCount());
  }

  // recupera um resumo do estudo
  public resumo(idEstudo: number): Observable<EstudoResumo> {
    return this.http
      .get(this.url + '/' + idEstudo + '/resumo')
      .pipe(map(this.extractObjectData),
          catchError(this.handleError),
          publishReplay(1),
          refCount());
  }


  // extrai lista da resposta http
  private extractListData(res: any) {
    return res as Estudo[];
  }

  // extrai objeto da resposta http
  private extractObjectData(res: any) {
    return res as Estudo;
  }

  private deletaVariaveisTransient(estudo: Estudo) {
    // mantém o questiorio montado na memória pra nao ser necessário carregar toda hora
    estudo.questionarioPreliminar = null;
    estudo.questionarioDadosPessoais = null;
    estudo.questionarioGrupoFamiliar = null;
    return estudo;
  }
}
